export default __webpack_public_path__ + "static/media/uncertainty.a727602e.svg";